import React from 'react'
import { Icon } from '@iconify/react';

const customStyles = `
.head-color {
  color: #CBA370; 
}
.box-text-size {
  font-size: 12px;
}
.card {
  background-color: var(--card-bg) !important;
  color: var(--card-text) !important;
  border-color: var(--card-bg) !important;
}
.text-muted {
  color: rgba(var(--card-text-rgb), 0.6) !important;
}
`;

const UnitCountOne = ({
    totalUsers = 0,
    totalUsersChange = 0,
    activeUserCount = 0,
    activeUserCountChange = 0,
    inActiveUserCount = 0,
    inActiveUserCountChange = 0,
    usersToday = 0,
    usersThisWeek = 0,
    usersThisMonth = 0,
    totalAssets = 0
}) => {
    // Format total assets to display in a readable format
    const formatAssets = (assets) => {
        if (assets >= 1000000) {
            return `$${(assets / 1000000).toFixed(2)}M`;
        } else if (assets >= 1000) {
            return `$${(assets / 1000).toFixed(2)}K`;
        }
        return `$${assets.toFixed(2)}`;
    };

    return (
        <>
            <style>{customStyles}</style>
            <div className="row row-cols-xxxl-7 row-cols-lg-7 row-cols-md-7 row-cols-sm-7 row-cols-7 g-3">
                <div className="col">
                    <div className="card shadow-none border h-100">
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <p className="text-muted fw-medium mb-3 box-text-size">Total Users</p>
                                    <h5 className="mb-0 head-color">{totalUsers}</h5>
                                </div>
                                <div className="bg-primary bg-opacity-10 p-2 rounded">
                                    <Icon
                                        icon="fluent-color:people-team-32"
                                        className="text-primary"
                                        width="18"
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-3">
                                <span className="text-muted small text-capitalize">{totalUsersChange}% from last month</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col">
                    <div className="card shadow-none border h-100">
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <p className="text-muted fw-medium mb-3 box-text-size">New Sign Ups</p>
                                    <h5 className="mb-0 head-color">{usersToday}</h5>
                                </div>
                                <div className="bg-warning bg-opacity-10 p-2 rounded">
                                    <Icon
                                        icon="fluent-color:person-add-20"
                                        className="text-warning"
                                        width="18"
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-3">
                                <span className="text-muted small">Today</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Card 3: Users Signed Up This Week */}
                <div className="col">
                    <div className="card shadow-none border h-100">
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <p className="text-muted fw-medium mb-3 box-text-size">New Sign Ups</p>
                                    <h5 className="mb-0 head-color">{usersThisWeek}</h5>
                                </div>
                                <div className="bg-warning bg-opacity-10 p-2 rounded">
                                    <Icon
                                        icon="fluent-color:people-add-20"
                                        className="text-warning"
                                        width="18"
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-3">
                                <span className="text-muted small">This Week</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Card 4: Users Signed Up This Month */}
                <div className="col">
                    <div className="card shadow-none border h-100">
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <p className="text-muted fw-medium mb-3 box-text-size">New Sign Ups</p>
                                    <h5 className="mb-0 head-color">{usersThisMonth}</h5>
                                </div>
                                <div className="bg-warning bg-opacity-10 p-2 rounded">
                                    <Icon
                                        icon="fluent-color:people-team-16"
                                        className="text-warning"
                                        width="18"
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-3">
                                <span className="text-muted small">This Month</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Card 5: Active Users (You might need to calculate this from other data) */}
                <div className="col">
                    <div className="card shadow-none border h-100">
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <p className="text-muted fw-medium mb-3 box-text-size">Active Users</p>
                                    <h5 className="mb-0 head-color">{activeUserCount}</h5>
                                </div>
                                <div className="bg-success bg-opacity-10 p-2 rounded">
                                    <Icon
                                        icon="fluent-color:people-community-20"
                                        className="text-success"
                                        width="18"
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-3">
                                <span className="text-muted small text-capitalize">{activeUserCountChange}% from last month</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Card 6: Inactive Users (You might need to calculate this) */}
                <div className="col">
                    <div className="card shadow-none border h-100">
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <p className="text-muted fw-medium mb-3 box-text-size">Inactive User</p>
                                    <h5 className="mb-0 head-color">{inActiveUserCount}</h5>
                                </div>
                                <div className="bg-info bg-opacity-10 p-2 rounded">
                                    <Icon
                                        icon="fluent-color:person-warning-16"
                                        className="text-info"
                                        width="18"
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-3">
                                <span className="text-muted small text-capitalize">{inActiveUserCountChange}% from last month</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Card 7: Total Assets */}
                <div className="col">
                    <div className="card shadow-none border h-100">
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <p className="text-muted fw-medium mb-0 font-size-2 box-text-size">Total Asset Under Management</p>
                                    <h5 className="mb-0 head-color">{formatAssets(totalAssets)}</h5>
                                </div>
                                <div className="bg-opacity-10 p-2 rounded">
                                    <Icon
                                        icon="fluent-color:savings-16"
                                        className="text-purple"
                                        width="18"
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-3">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UnitCountOne;